module.exports = __webpack_public_path__ + "img/kite_kitchen.299a64da.svg";